module.exports = __webpack_public_path__ + "static/media/am.39c5d05e.svg";